import React, { useState } from 'react';
import Panel from './Panel';
import CodeBlock from './CodeBlock';

interface ComponentShowcaseProps {
  id?: string;
  title: string;
  description?: string;
  component: React.ReactNode;
  code: string;
  className?: string;
}

const ComponentShowcase: React.FC<ComponentShowcaseProps> = ({
  id,
  title,
  description,
  component,
  code,
  className = ''
}) => {
  const [showCode, setShowCode] = useState(false);
  
  return (
    <div id={id} className={`mb-10 ${className}`}>
      <h3 className="text-osrs-gold text-xl font-bold uppercase mb-3">{title}</h3>
      
      {description && (
        <p className="text-osrs-yellow mb-4">{description}</p>
      )}
      
      <Panel variant="default" className="mb-4">
        <div className="p-4 flex items-center justify-center">
          {component}
        </div>
      </Panel>
      
      <div className="flex justify-end mb-2">
        <button 
          className="text-osrs-blue hover:text-osrs-gold underline text-sm"
          onClick={() => setShowCode(!showCode)}
        >
          {showCode ? 'Hide Code' : 'Show Code'}
        </button>
      </div>
      
      {showCode && (
        <CodeBlock code={code} language="tsx" />
      )}
    </div>
  );
};

export default ComponentShowcase; 